import React from "react";
import { PhoneCall } from "lucide-react";
import { trackEvent } from "../utils/analytics";

const PHONE = "+918651035362";

export default function CallNowButton() {
  const callNow = () => {
    trackEvent("call_click", { source: "floating_button" });
    window.location.href = `tel:${PHONE}`;
  };

  return (
    <button
      onClick={callNow}
      className="fixed bottom-5 left-5 z-[9999] flex items-center gap-2 rounded-full bg-[#354F37] px-4 py-3 text-white shadow-lg hover:bg-[#426045] transition md:hidden"
      aria-label="Call Now"
      type="button"
    >
      <PhoneCall size={20} />
      Call Now
    </button>
  );
}
